import gql from 'graphql-tag';

import postFragment from '~/shared/graphql-queries/posts/post-fragment';

export const findOnePostQueryRequest = `
  query findOnePostQuery($filter: FilterFindOnePostInput!) {
    findOnePostQuery(filter: $filter) {
      _id
      alias
      language
      isPublished
      metaTitle
      metaDescription
      image {
        path
      }
    }
  }
`;

export default gql`
    query findOnePostQuery($filter: FilterFindOnePostInput!) {
        findOnePostQuery(filter: $filter) {
            ...PostFragment
        }
    }
    ${postFragment}
`;
